import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import messages from '@/messages'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import VueScrollTo from 'vue-scrollto'
import FullCalendar from '@vendors/vue-full-calendar'

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(VeeValidate)
Vue.use(FullCalendar)
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 200,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

const i18n = new VueI18n({
  locale: 'en',
  messages
})

store.dispatch('auth/requestAutoLogin')
  .then(() => {
    // axios.interceptors.request.use(config => {
    //   store.dispatch('page/showLoader', true)
    //   return config
    // })
    initialize()
  })

const initialize = () => {
  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
